import { Intervention } from '@/app/components/action-plan/types';
import { getInterventionHighestRisk } from '@/utils';
import { useDisclosure } from '@cmpsr/components';

type ActiveInterventionCardControllerProps = {
  intervention: Intervention;
};

export default function useActiveInterventionCardController({ intervention }: ActiveInterventionCardControllerProps) {
  const { isOpen: isDetailsModalOpen, onOpen: onOpenDetailsModal, onClose: onCloseDetailsModal } = useDisclosure();

  const { reducedRisk, otherCancers } = getInterventionHighestRisk(intervention.riskImpact);

  const cancersAffected = intervention.riskImpact.filter(({ cancerType }) => cancerType !== 'overall');

  return {
    cancersAffected,
    isDetailsModalOpen,
    onCloseDetailsModal,
    onOpenDetailsModal,
    otherCancers,
    reducedRisk,
  };
}
